import { render, staticRenderFns } from "./SupplierListEntry.vue?vue&type=template&id=25d92b1c&"
import script from "./SupplierListEntry.vue?vue&type=script&lang=js&"
export * from "./SupplierListEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports